import type { AttendanceEventRecord } from '@/features/kitchen/storage/attendanceStorage'
import { kitchenTodayISO } from '@/features/kitchen/lib/kitchenDates'
import { loadJson, saveJson } from '@/features/kitchen/storage/persist'

export const DELMAN_ATTENDANCE_PREFIX = 'superoti.delman.attendance.'

export type DelmanDayAttendance = {
  delmanId: string
  delmanName: string
  kitchenName: string
  date: string
  shiftStart: string
  shiftEnd: string
  checkIn?: AttendanceEventRecord
  checkOut?: AttendanceEventRecord
}

export function todayDateKey(): string {
  return kitchenTodayISO()
}

function storageKey(delmanId: string, date: string): string {
  return `${DELMAN_ATTENDANCE_PREFIX}${date}.${delmanId}`
}

export function loadDelmanAttendance(
  delmanId: string,
  date = todayDateKey(),
): DelmanDayAttendance | null {
  return loadJson<DelmanDayAttendance>(storageKey(delmanId, date))
}

export function saveDelmanAttendance(record: DelmanDayAttendance): void {
  saveJson(storageKey(record.delmanId, record.date), record)
}

export function isDelmanCheckedInToday(delmanId: string, date = todayDateKey()): boolean {
  const record = loadDelmanAttendance(delmanId, date)
  return getDelmanAttendanceStatus(record) !== 'belum'
}

export type DelmanAttendanceStatus = 'belum' | 'masuk' | 'selesai'

export function getDelmanAttendanceStatus(record: DelmanDayAttendance | null): DelmanAttendanceStatus {
  if (!record?.checkIn) return 'belum'
  if (!record.checkOut) return 'masuk'
  return 'selesai'
}
